import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import TourInfo from "@common/images/info.svg";
import style from "./style.module.scss";

export function InfoIcon(props) {
  const className = `${style.icon} ${props.className}`;

  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      props.onClick();
    }
  };

  return (
    <Image
      tabIndex={props.tabIndex}
      className={className}
      src={TourInfo}
      alt="Tour Icon"
      onClick={onClick}
      onKeyDown={onKeyDown}
    />
  );
}

InfoIcon.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Callback for when Icon is clicked
   */
  onClick: PropTypes.func,
};

InfoIcon.defaultProps = {
  className: "",
};
